import React, { useState } from "react";
import images from "../../../../Utils/importImages";
import { Button, CircularProgress, TextField } from "@mui/material";
import { resetPassword } from "../../../../Redux/Apis/User-Apis";

function ResetPassword({
  setOpenResetPassword,
  setOpenResetPasswordPop,
  credential,
  credentialType,
}) {
  const [inputText, setInputText] = useState("");
  const [inputText1, setInputText1] = useState("");
  const [textError, setTextError] = useState("");
  const [textError1, setTextError1] = useState("");

  const onChangeInput = (e) => {
    validatePassword(e.target.value);
    setInputText(e.target.value);
  };
  const onChangeInput1 = (e) => {
    validatePassword1(e.target.value);
    setInputText1(e.target.value);
  };

  const [btnLoading, setBtnLoading] = useState(false);

  const handleSubmit = async () => {
    let structure = {
      password: inputText,
    };
    structure[credentialType] = credential;

    setBtnLoading(true);
    let otpResp = await resetPassword(
      structure,
      `/reset-password/${credentialType}`
    );
    setBtnLoading(false);

    if (otpResp.error == true) {
      return;
    }

    setOpenResetPassword(false);
    setOpenResetPasswordPop(false);
  };

  const validatePassword = (value) => {
    const passwordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/;

    if (!value) {
      setTextError("*Required");
      return false;
    }
    if (!passwordRegex.test(value)) {
      setTextError(
        "Password must be at least 6 characters long and include a mix of letters, numbers, and symbols (@$!%*#?&)"
      );
      return false;
    }

    setTextError("");
    return true;
  };
  const validatePassword1 = (value) => {
    if (!value) {
      setTextError1("*Required");
      return false;
    }
    if (value != inputText) {
      setTextError1("New Password and Confirm Password Should be Same");
      return false;
    }

    setTextError1("");
    return true;
  };

  return (
    <div className="register-login">
      <div
        className="back-text proxima_semibold color_endeavour font12"
        onClick={() => {
          setOpenResetPassword(false);
          setOpenResetPasswordPop(false);
        }}
      >
        BACK
      </div>

      <div className="header">
        <img
          src={images["user-login-icon.svg"]}
          alt=""
          className="login-icon"
        />
        <div className="title proxima_semibold color_black font22">
          Reset Password
        </div>
      </div>

      <div className="otp proxima_semibold color_black font12">
        Enter New Password for {credentialType.toUpperCase()} : {credential}
      </div>

      <div className="input-content">
        <TextField
          autoComplete="off"
          error={!!textError}
          helperText={
            textError ||
            "Use 6 or more characters with a mix of letters, numbers & symbols (@$!%*#?&"
          }
          value={inputText}
          onChange={onChangeInput}
          onBlur={() => validatePassword(inputText)}
          id="outlined-basic"
          label="Enter New Password"
          variant="outlined"
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              fontFamily: `var(--font-family-proxima_nova-regular)`,
              fontStyle: "normal",
              fontWeight: "400",
              "&.Mui-focused": {
                color: "#0057B7",
              },
            },
            "& .MuiOutlinedInput-root": {
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
            },
          }}
        />
      </div>
      <div className="input-content">
        <TextField
          autoComplete="off"
          error={!!textError1}
          helperText={
            textError1 || "New Password and Confirm Password Should be Same"
          }
          value={inputText1}
          onChange={onChangeInput1}
          onBlur={() => validatePassword1(inputText1)}
          id="outlined-basic"
          label="Confirm New Password"
          variant="outlined"
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              fontFamily: `var(--font-family-proxima_nova-regular)`,
              fontStyle: "normal",
              fontWeight: "400",
              "&.Mui-focused": {
                color: "#0057B7",
              },
            },
            "& .MuiOutlinedInput-root": {
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
            },
          }}
        />
      </div>

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={!inputText || !inputText1 || !!textError || !!textError1 || btnLoading}
        sx={{
          width: "100%",
          backgroundColor: "#0057B7",
          color: "#fff",
          fontSize: "16px",
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          //   fontWeight: "00",
          marginTop: "10px",
          textTransform: "none",
          "&:hover": { backgroundColor: "#0045A5" },
          "&:disabled": {
            backgroundColor: "#B0B0B0",
            color: "#fff",
            cursor: "not-allowed",
          },
        }}
      >
        {" "}
        {btnLoading ? (
          <CircularProgress size={24} sx={{ color: "white" }} />
        ) : (
          "Reset Password"
        )}
      </Button>

      <div className="tandc color_light-gray-black font14 proxima_regular">
        By proceeding, you agree to Stfares's{" "}
        <span className="color_endeavour">Privacy Policy, User Agreement</span>{" "}
        and <span className="color_endeavour">T&Cs</span>
      </div>
    </div>
  );
}

export default ResetPassword;
